// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeaderBottom_wrapper__3nN2C","container":"HeaderBottom_container__2kOmx","logo":"HeaderBottom_logo__A5pPZ","image":"HeaderBottom_image__1Pg5X"};